import { render } from "./FoodRestrictionView.vue?vue&type=template&id=1cca013e&scoped=true"
import script from "./FoodRestrictionView.vue?vue&type=script&lang=js"
export * from "./FoodRestrictionView.vue?vue&type=script&lang=js"

import "./FoodRestrictionView.vue?vue&type=style&index=0&id=1cca013e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cca013e"]])

export default __exports__